import React from 'react';

/**
 * CockpitChecklistStepsCard - "FROM YOUR CHECKLIST" numbered steps card for
 * a multi-step locate. Tapping a step jumps the stage/selection to that
 * step's zone/view/control.
 */
export const CockpitChecklistStepsCard = (props) => {
  const itemText = props.itemText;
  const phaseTitle = props.phaseTitle;
  const steps = props.steps || [];
  const selectedControlId = props.selectedControlId;
  const onStepClick = props.onStepClick;

  return (
    <section
      className="rounded-gc-card border p-3.5 flex flex-col gap-2.5"
      style={{ background: '#0B1820', borderColor: '#1F4A57' }}
      data-testid="cockpit-checklist-steps-card"
    >
      <div
        className="font-plex-mono text-[11px] font-semibold tracking-[0.1em]"
        style={{ color: 'var(--gc-cyan)' }}
      >
        FROM YOUR CHECKLIST
      </div>
      <div className="flex flex-col gap-0.5">
        <div className="font-plex-mono text-[15px] font-semibold" style={{ color: 'var(--gc-text-main)' }}>
          {itemText}
        </div>
        {phaseTitle && (
          <div className="font-plex-mono text-[11px]" style={{ color: 'var(--gc-text-muted)' }}>
            {phaseTitle}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1.5">
        {steps.map((step, i) => {
          const isSelected = step.control.id === selectedControlId;
          return (
            <button
              key={`${step.control.id}-${i}`}
              type="button"
              onClick={() => onStepClick && onStepClick(step)}
              className="flex items-center gap-2.5 min-h-[44px] px-2.5 rounded-gc-button border text-left cursor-pointer"
              style={{
                color: 'var(--gc-text-main)',
                background: isSelected ? 'var(--gc-current-row)' : 'var(--gc-checklist-card)',
                borderColor: isSelected ? 'var(--gc-cyan)' : 'var(--gc-border-card)',
              }}
              data-testid={`cockpit-step-${i}`}
            >
              <span
                className="font-plex-mono font-semibold flex items-center justify-center rounded-full flex-shrink-0"
                style={{
                  width: '24px',
                  height: '24px',
                  fontSize: '12px',
                  background: isSelected ? 'var(--gc-cyan)' : 'transparent',
                  color: isSelected ? '#04161C' : 'var(--gc-cyan)',
                  border: isSelected ? 'none' : '1.5px solid var(--gc-cyan)',
                }}
              >
                {i + 1}
              </span>
              <span className="flex-1 text-sm leading-snug">{step.text}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default CockpitChecklistStepsCard;
